import React from 'react';
import { cn } from '@/lib/utils';

interface Props {
  className?: string;
}

const Spinner = ({ className }: Props) => (
  <div
    className={cn(
      'animate-spin inline-block w-10 h-10 border-[3px] border-current border-t-transparent text-black rounded-full',
      className,
    )}
    role="status"
    aria-label="loading">
    <span className="sr-only">Loading...</span>
  </div>
);

export default Spinner;
